/* unplugin-vue-components disabled */import { render } from "./News.vue?vue&type=template&id=08372871&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=08372871&lang=scss&scoped=true"
import "./News.vue?vue&type=style&index=1&id=08372871&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08372871"]])

export default __exports__